const SearchResultSkeleton = () => {
    return (
        <div className="w-full flex gap-2">
            <div className="bg-gray-300 rounded-lg w-32 h-20 animate-pulse" />
            <div className="pt-2 flex flex-col gap-2">
                <div className="bg-gray-300 rounded-lg w-32 h-4 animate-pulse" />
                <div className="bg-gray-300 rounded-lg w-24 h-4 animate-pulse" />
            </div>
        </div>
    );
}

export default SearchResultSkeleton;